function getUserLocation() {
  const defaultLocation = {
    lat: 33.72159092853535,
    lng: 73.07941229786717,
  };

  return new Promise((resolve) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log("User location obtained: ", position);
          const { latitude, longitude } = position.coords;
          resolve({ lat: latitude, lng: longitude });
        },
        (error) => {
          console.warn(`Error(${error.code}): ${error.message}`);
          resolve(defaultLocation);
          //"ABCCCCCCCCCCCCCCCCC");
        },
        { timeout: 10000 }
      );
    } else {
      console.warn("Geolocation is not supported by this browser.");
      resolve(defaultLocation);
    }
  });
}

export default getUserLocation;
